import React, { useState } from 'react';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import LineItem from './LineItem';
import { formatCurrency } from '../../billing/timesheets/BillingTools';

const SubsistenceExpenses = ({ tariff, quote, timesheet, onChange, requireDates = false }) => {

    if (!quote && !timesheet) throw new Error("quote or timesheet is required");
    if (!tariff) throw new Error("tariff is required");

    const items = quote || timesheet;

    const [total, setTotal] = useState(items.netSectionTotal('subsistence'));

    const updateQuantity = (item) => {
        console.log('SubsistenceExpenses.updateQuantity', item)
        items.apply(item);
        setTotal(items.netSectionTotal('subsistence'));
        onChange();
    }

    return (
        <Paper style={{ padding: '0rem 1rem 1rem 1rem', marginTop: '1rem' }}>
            <Grid container spacing={2} >
                <Grid item xs={8}>
                    <Typography variant="h6">Subsistence Allowance</Typography>
                </Grid>
                <Grid item xs={4}>
                    {
                        quote &&
                        <Typography variant="h6" color="textSecondary">Net Total {formatCurrency(total)}</Typography>
                    }
                </Grid>
            </Grid>
            <Typography variant="subtitle2">Enter the number of days / hours</Typography>
            <Grid container style={{ marginTop: '1rem' }}>
                <Grid container>
                    <LineItem category="expenses" tariff={tariff} subsection="subsistence" code='fullDay' quote={quote} timesheet={timesheet}
                        onChange={updateQuantity} dates={requireDates}
                    />
                </Grid>
                <Grid container>
                    <LineItem category="expenses" tariff={tariff} subsection="subsistence" code='partDay' quote={quote} timesheet={timesheet} onChange={updateQuantity} dates={requireDates} />
                </Grid>
                <Grid container>
                    <LineItem category="expenses" tariff={tariff} subsection="subsistence" code='night' quote={quote} timesheet={timesheet} onChange={updateQuantity} dates={requireDates} />
                </Grid>
            </Grid>
        </Paper>
    );
}

export default SubsistenceExpenses;